import {createSlice} from '@reduxjs/toolkit';
import {ComapnyDetailsDto} from 'src/shared/services/company/dto/comapny-details-dto';

interface CompaniesInitialState {
  companyDetails: ComapnyDetailsDto | undefined;
}

const initialState: CompaniesInitialState = {
  companyDetails: undefined,
};

const companiesSlice = createSlice({
  name: 'companies',
  initialState: initialState,
  reducers: {
    setCompanyDetails: (state, action) => {
      state.companyDetails = action.payload;
    },
  },
});

export const {setCompanyDetails} = companiesSlice.actions;

export default companiesSlice.reducer;
